<template>
  <v-card
    ref="mesa-card"
    elevation="4"
    :class="!pedido ? 'libre' : 'con-comensales'"
    class="rounded-lg ficha-generica"
    :color="pedido ? '#ffff007d' : ''"
    @click="goPedido"
    style="position: relative"
    :disabled="pedido && pedido.id == $store.state.impresion.pedidoOcupado"
  >
    <v-responsive
      class="rounded-0"
      :aspect-ratio="1.618"
    >
      <v-img src="/img/fondoFichaFunEats.svg">
        <v-card-text class="pa-0">
          <v-list
            :style="'padding-left: ' +
              porcentaje004 +
              'px !important;' +
              'padding-right: ' +
              porcentaje004 +
              'px !important;'
              "
            class="pa-0 border"
            color="transparent"
          >
            <v-list-item
              :style="'min-height: ' + porcentajeHeight + 'px !important;'"
              class="pa-0 ma-0"
            >
              <v-list-item-content class="pa-0">
                <v-list-item-title
                  :style="'font-size: ' + porcentaje014 + 'px !important;'"
                  class="text-uppercase font-weight-black black--text"
                >
                  {{ nombreMostrar }}
                </v-list-item-title>
                <v-list-item-subtitle
                  :style="'font-size: ' + porcentaje014 + 'px !important;'"
                  v-if="pedidoComputed.nombrePersonalizadoTpv"
                  class="font-weight-black cyan--text"
                >
                  {{ pedidoComputed.nombrePersonalizadoTpv }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action class="pa-0 ma-0">
                <v-list-item-action-text
                  v-if="numeroMesa !== undefined"
                  class="font-weight-black cyan--text text--lighten-2 pa-0"
                  :style="'font-size: ' + porcentaje038 + 'px !important;'"
                >
                  <span v-if="numeroMesa <= 9">0</span>{{ numeroMesa }}
                </v-list-item-action-text>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>

        <v-card-actions
          style="position: absolute; bottom: 0px; width: 100%"
          class=""
          v-if="pedidoComputed"
        >
          <v-row
            align="end"
            class="pb-1"
          >
            <v-col
              class="py-0"
              :class="$vuetify.breakpoint.xsOnly ? 'px-2' : ''"
              cols="6"
            >
              <div
                v-if="comensales"
                class="text-no-wrap"
              >
                <v-icon
                  :style="'font-size: ' + porcentaje014 + 'px !important;'"
                  color="blue-grey lighten-1"
                  class="mr-1"
                >
                  mdi-account-outline
                </v-icon>
                <span
                  :style="'font-size: ' + porcentaje014 + 'px !important;'"
                  class="mr-1 font-weight-medium black--text"
                >{{ comensales }}</span>
              </div>
              <div class="text-no-wrap mt-n2">
                <v-icon
                  :style="'font-size: ' + porcentaje014 + 'px !important;'"
                  color="blue-grey lighten-1"
                  class="mr-1"
                >
                  mdi-clock-time-eight-outline
                </v-icon>
                <span
                  :style="'font-size: ' + porcentaje014 + 'px !important;'"
                  class="font-weight-medium black--text"
                >{{
                  pedidoComputed.fechaMostrarContador }}</span>
              </div>
            </v-col>
            <v-col
              class="py-0 px-2 pr-lg-3 text-right"
              cols="6"
            >
              <span
                :style="'font-size: ' + porcentaje016 + 'px !important;'"
                class="font-weight-black text-no-wrap"
              >{{
                precioTotal }}€</span>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-img>
    </v-responsive>
  </v-card>
</template>

<script>
import moment from "moment";
import ProductosCarrito from "@/components/ProductosCarrito.vue";
import { mapState } from "vuex";
import Cobrar from "./Cobrar.vue";
import { mostrarMoneda } from "@/utils/helper.utils.js";

export default {
  components: { ProductosCarrito, Cobrar },
  props: {
    mesa: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: false,
      alturaCard: false,
    };
  },
  computed: {
    porcentaje038() {
      const x = this.windowWidth;
      const y = this.windowHeight;
      if (this.$refs["mesa-card"] && this.$refs["mesa-card"].$el.clientHeight)
        this.alturaCard = this.$refs["mesa-card"].$el.clientHeight;
      if (this.alturaCard) {
        let aux = parseInt(this.alturaCard * 0.38);
        return aux;
      }
      return "";
    },
    porcentaje014() {
      const x = this.windowWidth;
      const y = this.windowHeight;
      if (this.$refs["mesa-card"] && this.$refs["mesa-card"].$el.clientHeight)
        this.alturaCard = this.$refs["mesa-card"].$el.clientHeight;
      if (this.alturaCard) {
        let aux = parseInt(this.alturaCard * 0.11);
        return aux;
      }
      return "";
    },
    porcentaje016() {
      const x = this.windowWidth;
      const y = this.windowHeight;
      if (this.$refs["mesa-card"] && this.$refs["mesa-card"].$el.clientHeight)
        this.alturaCard = this.$refs["mesa-card"].$el.clientHeight;
      if (this.alturaCard) {
        let aux = parseInt(this.alturaCard * 0.14);
        return aux;
      }
      return "";
    },
    porcentajeHeight() {
      const x = this.windowWidth;
      const y = this.windowHeight;
      if (this.$refs["mesa-card"] && this.$refs["mesa-card"].$el.clientHeight)
        this.alturaCard = this.$refs["mesa-card"].$el.clientHeight;
      if (this.alturaCard) {
        let aux = parseInt(this.alturaCard * 0.4);
        return aux;
      }
      return "";
    },
    porcentaje004() {
      const x = this.windowWidth;
      const y = this.windowHeight;
      if (this.$refs["mesa-card"] && this.$refs["mesa-card"].$el.clientHeight)
        this.alturaCard = this.$refs["mesa-card"].$el.clientHeight;
      if (this.alturaCard) {
        let aux = parseInt(this.alturaCard * 0.06);
        return aux;
      }
      return "";
    },
    pedido() {
      if (this.mesa.pedido) {
        var f = this.$store.state.pedidos.pedidosRealizandoTpv.find(
          (p) => p.id == this.mesa.pedido
        );
        //if (!f) this.$store.dispatch("pedidos/liberarMesa", this.mesa.id);

        return f ? f : null;
      } else {
        return false;
      }
    },
    mesaLibre() {
      return !this.mesa.pedido;
    },
    mensajesComputados() {
      return this.pedido.historial
        ? this.pedido.historial
          .filter((p) => p.mensaje.includes("Mensaje desde la web"))
          .map((p) => {
            return {
              ...p,
              fechaMostrar: moment.unix(p.fecha).format("DD-MM-YYYY HH:mm"),
            };
          })
        : [];
    },
    pedidoComputed() {
      if (this.pedido) {
        let tz =
          this.pedido.copyRest &&
            this.pedido.copyRest.confGeneral &&
            this.pedido.copyRest.confGeneral.zonaHoraria
            ? this.pedido.copyRest.confGeneral.zonaHoraria
            : "Europe/Madrid";
        let tiempo =
          this.pedido.modo == "domicilio"
            ? this.pedido.copyRest
              ? this.pedido.copyRest.tiempoDomicilio
              : 0
            : this.pedido.copyRest
              ? this.pedido.copyRest.tiempoRecogida
              : 0;
        let actualMoment = moment(this.$store.state.horaActual);
        let fechaMoment = moment(this.pedido.fechaServidor.toDate()).tz(tz);
        let entregaMoment = fechaMoment.clone().add(tiempo, "minutes");
        var durantion = moment.duration(actualMoment.diff(fechaMoment));
        return {
          ...this.pedido,
          fechaMostrarContador: parseInt(durantion.asMinutes()),

          fechaMostrar: moment(this.pedido.fechaServidor.toDate())
            .tz(
              !!this.pedido.copyRest.confGeneral.zonaHoraria
                ? this.pedido.copyRest.confGeneral.zonaHoraria
                : "Europe/Madrid"
            )
            .format("HH:mm"),
        };
      } else {
        return false;
      }
    },
    ...mapState({
      pedidoViendo: (state) => state.pedidos.pedidoEditandoObj,
    }),
    // pedidoViendo() {
    // 	return this.$store.state.pedido.pedidoEditandoObj;
    // },
    pedidoEditando: {
      get() {
        return this.$store.state.pedidos.pedidoEditando;
      },
      set(v) {
        this.$store.commit("pedidos/setPedidoEditando", v);
      },
    },
    // pedidoEditando: {
    //   get() {
    //     return this.$store.state.pedidos.pedidoEditandoObj;
    //   },
    //   set(v) {
    //     this.$store.commit("pedidos/setPedidoEditandoObj", v);
    //   },
    // },
    nombreMostrar() {
      if (!this.pedido) {
        return "LIBRE";
      }
      var res = "";

      switch (this.pedido && this.pedido.modo) {
        case "mesa":
          //res = "Mesa · " + this.pedido.numPedidoRest;
          res = "Mesa";
          break;
      }
      return res;
    },
    numeroMesa() {
      if (this.mesa.nombre) {
        var mesaNumero = this.mesa.nombre.split(" ");
        return mesaNumero[mesaNumero.length - 1];
      } else {
        return undefined;
      }
    },
    nombreClienteMostrar() {
      if (this.pedido) {
        return this.pedido.copyUser && this.pedido.copyUser.phoneNumber
          ? this.pedido.copyUser.phoneNumber
          : this.pedido.copyUser && this.pedido.copyUser.displayName
            ? this.pedido.copyUser.displayName
            : this.pedido.copyUser && this.pedido.copyUser.email
              ? this.pedido.copyUser.email
              : "Cliente";
      }
    },
    comensales() {
      return this.pedido && this.pedido.comensales
        ? this.pedido.comensales
        : false;
    },
    color() {
      if (this.pedido) {
        switch (this.pedido.canalVenta) {
          case "propio": //Online propio
            return "2px solid #56a7a8";
          case "glovo":
            return "2px solid #f9c52e";
          case "justeat":
            return "2px solid #f27700";
          case "ubereats":
            return "2px solid #4fc83d";
          case "funeats":
            return "2px solid #56a7a8";
          case "tpv":
            return "2px solid #56a700";
        }
      }
    },
    precioTotal() {
      return this.pedido ? mostrarMoneda(this.pedido.precioTotal) : 0;
    },
  },
  methods: {
    calcularPorcentaje(p = 0.3) {
      if (this.$refs["mesa-card"]) {
        let aux = parseInt(this.$refs["mesa-card"].$el.clientHeight * p);
        return aux;
      }
      return "";
    },
    goPedido() {
      if (!!this.pedido && !!this.pedido.cobrado) {
        return this.$store.dispatch("pedidos/liberarMesa", this.mesa.id);
      } else if (!!this.pedido) {
        this.pedidoEditando = this.pedido.id;
        this.$store.commit("pedidos/setModoPantalla", "pedidoCarrito");
        this.$store.commit("pedidos/setPedidoDialog", true);
      } else {
        let modoObj = this.$store.state.datosTpv.modos.find(
          (m) => m.id == this.mesa.modo
        );
        this.$store.commit("pedidos/setPedidoEditandoObjValor", {
          key: "copyMesa",
          value: this.mesa,
        });
        this.$store.commit("pedidos/setPedidoEditandoObjValor", {
          key: "modoId",
          value: this.mesa.modo,
        });
        this.$store.commit("pedidos/setPedidoEditandoObjValor", {
          key: "modoCopy",
          value: !!modoObj ? modoObj : {},
        });
        this.$store.commit("pedidos/setPedidoEditandoObjValor", {
          key: "uid",
          value: "0",
        });
        this.$store.commit("pedidos/setPedidoEditandoObjValor", {
          key: "copyUser",
          value: {
            displayName: "Contado",
          },
        });
        if (this.mesa.preguntarComensales) {
          // this.$store.commit("pedidos/setPedidoEditandoObjValor", {
          //   key: "mesa",
          //   value: this.mesa.id,
          // });
          this.$store.commit("pedidos/setModoPantalla", "seleccionComensales");
          this.$store.commit("pedidos/setPedidoDialog", true);
        } else {
          this.crearPedido();
        }
      }
      // this.pedidoEditandoObj = this.pedido;
      // this.$router.push("/pedido/" + this.pedidoViendo.id);
    },
    crearPedido() {
      this.$store.dispatch("pedidos/crearPedidoEnMesa", {
        mesa: this.mesa,
        comensales: null,
      });
    },
    myEventHandler() {
      this.alturaCard = this.$refs["mesa-card"].$el.clientHeight;
    },
  },

  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  mounted() {
    window.addEventListener("resize", this.myEventHandler);
    this.myEventHandler();
  },
};
</script>

<style></style>